module.exports = __webpack_public_path__ + "static/img/link1.288062d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/links/link1.png
// module id = pudG
// module chunks = 12